// This file tests timezone handling in the date formatting for reminders

export function testTimezoneHandling(dateStr: string) {
  console.log('Timezone Investigation:');
  console.log('---------------------------------------');
  console.log('Raw date string:', dateStr);
  console.log('Browser timezone:', Intl.DateTimeFormat().resolvedOptions().timeZone);
  console.log('UTC offset (minutes):', new Date().getTimezoneOffset());
  
  // Test parsing without timezone specified (uses local timezone)
  const localDate = new Date(dateStr);
  console.log('Parsed as local date:', localDate.toString());
  console.log('Local date ISO:', localDate.toISOString());
  console.log('Local formatted:', localDate.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric', 
    year: 'numeric'
  }));
  
  // Test parsing with explicit Z (UTC)
  const utcDate = new Date(dateStr + 'T00:00:00Z');
  console.log('Parsed as UTC date:', utcDate.toString());
  console.log('UTC date ISO:', utcDate.toISOString());
  console.log('UTC formatted:', utcDate.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }));
  
  // Test explicit timezone approaches
  const dateOptions: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
  };
  console.log('Using explicit UTC timezone:', new Date(dateStr).toLocaleDateString('en-US', dateOptions));
  
  // Show difference in days
  const dayDiff = Math.floor((utcDate.getTime() - localDate.getTime()) / (1000 * 60 * 60 * 24));
  console.log('Days difference between UTC and local interpretation:', dayDiff);
  
  return {
    localFormatted: localDate.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }),
    utcFormatted: new Date(dateStr).toLocaleDateString('en-US', dateOptions)
  };
} 